// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardForm-PreFormContent_cls1__Q7wEK","cls2":"VeloCardForm-PreFormContent_cls2__Ytn-V VeloCardForm-PreFormContent_cls1__Q7wEK"};